import classNames from 'classnames';

const getDynamicClasses = (alignment, removeBottomPadding, removeTopPadding, src) => {
    return classNames({
        container: true,
        'text-media-slide': true,
        'text-media-carousel-has-image': src,
        'text-left-image-right': alignment === 'left',
        'text-right-image-left': alignment === 'right',
        'text-top-image-bottom': alignment === ('center' || 'text-top-image-bottom'),
        'text-bottom-image-top': alignment === 'text-bottom-image-top',
        'remove-bottom-padding': !!removeBottomPadding,
        'remove-top-padding': !!removeTopPadding,
    });
};

export default getDynamicClasses